import OrderExportPage from './order-export';

export default OrderExportPage;